import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { CustomMainContent, DropDownFilterDates } from '../../../components'
import CardNumber from '../../../components/common/NewUi/CardNumber'
import CardProgress from '../../../components/common/NewUi/CardProgress'
import Meanings from '../../../components/common/NewUi/Meanings'
import { onGetAllAlumsByGroups } from '../../../api'
import { Dropdown, Space } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { CardBarChar } from '../../../components/common/NewUi/CardBarChar'
import { CardBarCharSimiVR } from '../../../components/common/NewUi/CardBarCharSimiVR'
import { CardBarRadarSimiAR } from '../../../components/common/NewUi/CardBarRadarSimiAR'
import RankingSimiAR from '../../../components/common/NewUi/RankingSimiAR'
const baseResponseCorrect = {
    "Inicio_1._¿Número_de_anaqueles_considerados_en_farmacia?": "C",
    "Inicio_2._¿Qué_sustenta_nuestra_estrategia_de_acomodo_de_anaqueles_y_exhibiciones?": "C",
    "Inicio_3._¿A_qué_llamamos_'Punto_caliente'?": "A",
    "Inicio_4._¿Por_qué_es_importante_contar_con_anaqueles_bien_acomodados_y_frenteados?": "B",
    "Inicio_5._¿Cuántas_exhibiciones_deben_ir_en_el_mostrador?": "A",
    "Inicio_6._Un_anaquel_se_compone_de_copete,_charola,_cintillo,_stopper_y_productos.": "A",
    "Inicio_7._El_copete_de_un_anaquel_indica_únicamente_la_fracción_del_producto.": "B",
    "Inicio_8._¿Qué_función_tiene_el_cintillo_y_el_stopper?": "C",
    "Inicio_9._¿Qué_es_un_copete?": "B",
    "Inicio_10._¿Qué_distribuciones_de_mostrador_y_anaqueles_son_más_comunes_en_nuestras_farmacias?": "C",

    "Final_1._¿Número_de_anaqueles_considerados_en_farmacia?": "C",
    "Final_2._¿Qué_sustenta_nuestra_estrategia_de_acomodo_de_anaqueles_y_exhibiciones?": "C",
    "Final_3._¿A_qué_llamamos_'Punto_caliente'?": "A",
    "Final_4._¿Por_qué_es_importante_contar_con_anaqueles_bien_acomodados_y_frenteados?": "B",
    "Final_5._¿Cuántas_exhibiciones_deben_ir_en_el_mostrador?": "A",
    "Final_6._Un_anaquel_se_compone_de_copete,_charola,_cintillo,_stopper_y_productos.": "A",
    "Final_7._El_copete_de_un_anaquel_indica_únicamente_la_fracción_del_producto.": "B",
    "Final_8._¿Qué_función_tiene_el_cintillo_y_el_stopper?": "C",
    "Final_9._¿Qué_es_un_copete?": "B",
    "Final_10._¿Qué_distribuciones_de_mostrador_y_anaqueles_son_más_comunes_en_nuestras_farmacias?": "C",

    "T1L1": "5",
    "T1L2": "5",
    "T1L3": "5",
    "T2L1": "5",
    "T2L2": "5",
    "T2L3": "5",
    "T3L1": "5",
    "T3L2": "5",
    "T3L3": "6",
    "T4L1": "5",
    "T4L2": "5",
    "T4L3": "10",
}

export const LearningDashboardSimiAr = () => {
    const [usersAndProgress, setUsersAndProgress] = useState({
        totalUsers: 0,
        activeUsers: 0,
        inactiveUsers: 0,
        finishedUsers: 0,
    })
    const [infoModules, setinfoModules] = useState({
        "inicio": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "final": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "T1L1": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "T1L2": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "T1L3": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "T2L1": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "T2L2": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "T2L3": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "T3L1": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "T3L2": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "T3L3": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "T4L1": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "T4L2": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "T4L3": { intents: 0, corrects: 0, fails: 0, time: 0 },
    })
    const [grupsInfo, setgrupsInfo] = useState({});
    const [groupSelected, setGroupSelected] = useState("TODOS");
    const { arrayData } = useSelector(state => state.table);
    const [responseRanking, setResponseRanking] = useState([]);
    const { groups } = useSelector((state) => state.vrlSlice);
    const [datesFilter, setDatesFilter] = useState({
        start: "Wed Jan 01 2025 00:00:00 GMT-0600 (hora estándar central)",
        end: "Tue Dec 30 2025 23:59:59 GMT-0600 (hora estándar central)"
    })

    useEffect(() => {
        const getDataFormated = async () => {

            // users 
            let grupsInfo = {}
            let users = 0
            const grups = await onGetAllAlumsByGroups(groups)
            grups.forEach(grup => {
                grupsInfo[grup.group] = {
                    "T1L1": 0,
                    "T1L2": 0,
                    "T1L3": 0,
                    "T2L1": 0,
                    "T2L2": 0,
                    "T2L3": 0,
                    "T3L1": 0,
                    "T3L2": 0,
                    "T3L3": 0,
                    "T4L1": 0,
                    "T4L2": 0,
                    "T4L3": 0,
                }
                if (groupSelected === grup.group || groupSelected === "TODOS") {
                    users += grup.students.length
                }
            })
            setUsersAndProgress(actual => ({ ...actual, totalUsers: users }));

            // Convertir las fechas a objetos Date para comparación correcta
            const filterDateResponse = arrayData.filter(item => {
                const itemDate = new Date(item.Fecha_y_hora);
                const startDate = new Date(datesFilter.start);
                const endDate = new Date(datesFilter.end);
                return itemDate >= startDate && itemDate <= endDate;
            });

            const unicsResponses = new Set(filterDateResponse.map(obj => obj.matricula));
            const unicsResponsesFinishd = new Set(
                filterDateResponse
                    .filter(obj => obj["Final_10._¿Qué_distribuciones_de_mostrador_y_anaqueles_son_más_comunes_en_nuestras_farmacias?"] != null)
                    .map(obj => obj.matricula)
            );
            setUsersAndProgress(actual => ({ ...actual, activeUsers: unicsResponses.size - unicsResponsesFinishd.size }));
            setUsersAndProgress(actual => ({ ...actual, inactiveUsers: users - unicsResponses.size }));
            setUsersAndProgress(actual => ({ ...actual, finishedUsers: unicsResponsesFinishd.size }));


            const filtrados = filterDateResponse.filter(obj => unicsResponsesFinishd.has(obj.matricula));

            let userFormatedRanking = []

            let infoModules = {
                "inicio": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "final": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "T1L1": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "T1L2": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "T1L3": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "T2L1": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "T2L2": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "T2L3": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "T3L1": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "T3L2": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "T3L3": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "T4L1": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "T4L2": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "T4L3": { intents: 0, corrects: 0, fails: 0, time: 0 },
            }

            // const trash = []
            // let algomas = 0
            filtrados.forEach(response => {
                // if (response["Inicio_4._¿Por_qué_es_importante_contar_con_anaqueles_bien_acomodados_y_frenteados?"]
                //     // || response["Final_1._¿Número_de_anaqueles_considerados_en_farmacia?"]
                // ) {

                //     trash.push(response)
                // }
                let fails = 0
                let corrects = 0
                Object.keys(baseResponseCorrect).forEach(key => {
                    if (key.includes("._") && response[key]) {
                        // console.log(response)
                        if (key.includes("Inicio") && (response[key] === baseResponseCorrect[key])) {
                            // if (response.Nombre === "Colin Lomas Eduardo Francisco") {
                            // console.log(response[key])
                            // algomas++
                            // console.log(algomas)
                            infoModules.inicio.corrects++
                            infoModules.inicio.intents += 1
                            infoModules.inicio.time = infoModules.inicio.time + parseInt(response.tiempo_total.split(' ')[0])
                        }
                        if (key.includes("Inicio") && (response[key] !== baseResponseCorrect[key])) {
                            infoModules.inicio.fails += 1
                            infoModules.inicio.intents += 1
                            infoModules.inicio.time = infoModules.inicio.time + parseInt(response.tiempo_total.split(' ')[0])
                        }
                        if (key.includes("Final") && (response[key] === baseResponseCorrect[key])) {
                            infoModules.final.corrects += 1
                            infoModules.final.intents += 1
                            infoModules.final.time = infoModules.inicio.time + parseInt(response.tiempo_total.split(' ')[0])
                        }
                        if (key.includes("Final") && (response[key] !== baseResponseCorrect[key])) {
                            infoModules.final.fails += 1
                            infoModules.final.intents += 1
                            infoModules.final.time = infoModules.inicio.time + parseInt(response.tiempo_total.split(' ')[0])
                        }
                    }
                    else if (response[key]) {

                        infoModules[key].time = infoModules[key].time + parseInt(response.tiempo_total.split(' ')[0])
                        infoModules[key].intents += 1
                        //   if (key === "T4L1") {
                        //       console.log(response)
                        //   }
                        if (response[key] === baseResponseCorrect[key]) {
                            infoModules[key].corrects += parseInt(response[key])
                            corrects += parseInt(response[key])
                            grupsInfo[response.grupo][key] += parseInt(response[key])
                            //   if (key === "T2L1") {
                            //       console.log(parseInt(response[key]))
                            //   }
                        }
                        else {
                            //   if (key === "T2L1") {
                            //   console.log(parseInt(baseResponseCorrect[key]), parseInt(response[key]))
                            //   }
                            infoModules[key].fails += parseInt(baseResponseCorrect[key]) - parseInt(response[key])
                            fails += parseInt(baseResponseCorrect[key]) - parseInt(response[key])
                        }
                    }
                })
                userFormatedRanking.push({ ...response, fails, corrects })
            })
            // console.log(trash)
            setgrupsInfo(grupsInfo)
            console.log(infoModules)
            //   console.log("---")
            const resultado = {};
            userFormatedRanking.forEach(item => {
                const matricula = item.matricula;

                if (!resultado[matricula]) {
                    // Si no existe aún, inicializa el objeto
                    resultado[matricula] = { ...item };
                    resultado[matricula].corrects = Number(item.corrects) || 0;
                    resultado[matricula].fails = Number(item.fails) || 0;
                } else {
                    // Si ya existe, suma los corrects y fails y reemplaza el resto
                    resultado[matricula].corrects += Number(item.corrects) || 0;
                    resultado[matricula].fails += Number(item.fails) || 0;
                    resultado[matricula] = {
                        ...resultado[matricula],
                        ...item,
                        corrects: resultado[matricula].corrects,
                        fails: resultado[matricula].fails
                    };
                }
            });
            //   console.log(Object.values(resultado)
            //       .filter(item => item.corrects !== 0 || item.fails !== 0)
            //       .sort((a, b) => a.fails - b.fails))
            setResponseRanking(Object.values(resultado)
                .filter(item => item.corrects !== 0 || item.fails !== 0)
                .sort((a, b) => a.fails - b.fails))

            setinfoModules(infoModules)

        }
        getDataFormated()
    }, [groupSelected, groups, datesFilter])

    const getDataPerModules = (modules, multiplo = 1) => {
        let promedioTimeDivider = multiplo === 1 ? 3 : 1
        let promedio = 0
        let errorsPromedio = 0
        let timePromedio = 0
        modules.forEach(module => {
            promedio += ((parseInt(infoModules[module].corrects) / parseInt(infoModules[module].intents)) * multiplo)
            errorsPromedio += ((parseInt(infoModules[module].fails) / parseInt(infoModules[module].intents)) * multiplo)
            timePromedio += parseInt(infoModules[module].time) / parseInt(infoModules[module].intents) * multiplo
        })
        return { promedio: Math.round(promedio), errorsPromedio: Math.round(errorsPromedio), timePromedio: timePromedio / promedioTimeDivider }
    }

    return (
        <div style={{ background: "rgba(27, 20, 100, 0.1)" }} className='w-full h-screen overflow-scroll'>
            <CustomMainContent>
                <div className="flex w-full min-w-[450px] h-full pr-4">
                    <div className="w-full ">
                        <div className="flex py-3 gap-x-4 pr-6 items-center justify-between">
                            <p className="text-[#686868] text-sm font-semibold font-inter">Usuarios y avance</p>
                            <section className='flex gap-4 text-black'>
                                <DropDownFilterDates
                                    callBack={(start, end, _, { startDate, endDate }, beforeText) => {
                                        setDatesFilter({ start, end })
                                    }}
                                />
                                <Dropdown
                                    className='cursor-pointer'
                                    menu={{
                                        items: groups.map(group => ({ key: group._id, label: group.name })),
                                        onClick: ({ key }) => { console.log(key) }
                                    }}
                                >
                                    <Space>
                                        <p className="text-black "> {groupSelected}</p>
                                        <DownOutlined />
                                    </Space>
                                </Dropdown>
                            </section>
                        </div>
                        <div className="flex gap-x-4 overflow-x-auto pb-2 ">
                            <CardNumber newUsers={10} title={"Total de usuarios"} value={usersAndProgress.totalUsers} color="text-[#282828]" />
                            <CardNumber newUsers={10} title={"Usuarios activos"} value={usersAndProgress.activeUsers} color="text-[#55AE70]" />
                            <CardNumber newUsers={10} title={"Usuarios inactivos"} value={usersAndProgress.inactiveUsers} color="text-[#AE5555]" />
                            <CardNumber newUsers={10} title={"Cursos terminados"} value={usersAndProgress.finishedUsers} color="text-[#282828]" />
                        </div>
                        <div className="flex py-3 gap-x-4 items-center">
                            <p className="text-[#686868] text-sm font-semibold">Promedio General y por Módulo</p>
                        </div>
                        <div className="flex max-w-[1040px]  gap-x-4 overflow-x-scroll  overflow-y-auto pb-2">
                            <CardProgress module={"Curso total"} newUsers={100} title={"Aciertos promedio"}
                                value={getDataPerModules(["T1L1", "T1L2", "T1L3", "T2L1", "T2L2", "T2L3", "T3L1", "T3L2", "T3L3", "T4L1", "T4L2", "T4L3"]).promedio}
                                maxValue={66} color="text-[#282828]"
                                time={getDataPerModules(["T1L1", "T1L2", "T1L3", "T2L1", "T2L2", "T2L3", "T3L1", "T3L2", "T3L3", "T4L1", "T4L2", "T4L3"]).timePromedio}
                                repetitions={getDataPerModules(["T1L1", "T1L2", "T1L3", "T2L1", "T2L2", "T2L3", "T3L1", "T3L2", "T3L3", "T4L1", "T4L2", "T4L3"]).errorsPromedio}>
                            </CardProgress>
                            <CardProgress module={"Tema 1"} newUsers={100} title={"Aciertos promedio"}
                                value={getDataPerModules(["T1L1", "T1L2", "T1L3"]).promedio}
                                maxValue={15} color="text-[#282828]"
                                time={getDataPerModules(["T1L1", "T1L2", "T1L3"]).timePromedio}
                                repetitions={getDataPerModules(["T1L1", "T1L2", "T1L3"]).errorsPromedio}>
                            </CardProgress>
                            <CardProgress module={"Tema 2"} newUsers={100} title={"Aciertos promedio"}
                                value={getDataPerModules(["T2L1", "T2L2", "T2L3"]).promedio}
                                maxValue={15} color="text-[#282828]"
                                time={getDataPerModules(["T2L1", "T2L2", "T2L3"]).timePromedio}
                                repetitions={getDataPerModules(["T2L1", "T2L2", "T2L3"]).errorsPromedio}>
                            </CardProgress>
                            <CardProgress module={"Tema 3"} newUsers={100} title={"Aciertos promedio"}
                                value={getDataPerModules(["T3L1", "T3L2", "T3L3"]).promedio}
                                maxValue={16} color="text-[#282828]"
                                time={getDataPerModules(["T3L1", "T3L2", "T3L3"]).timePromedio}
                                repetitions={getDataPerModules(["T3L1", "T3L2", "T3L3"]).errorsPromedio}>
                            </CardProgress>
                            <CardProgress module={"Tema 4"} newUsers={100} title={"Aciertos promedio"}
                                value={getDataPerModules(["T4L1", "T4L2", "T4L3"]).promedio}
                                maxValue={20} color="text-[#282828]"
                                time={getDataPerModules(["T4L1", "T4L2", "T4L3"]).timePromedio}
                                repetitions={getDataPerModules(["T4L1", "T4L2", "T4L3"]).errorsPromedio}>
                            </CardProgress>
                            <CardProgress module={"inicio"} newUsers={100} title={"Aciertos promedio"}
                                value={getDataPerModules(["inicio"], 10).promedio}
                                maxValue={10} color="text-[#282828]"
                                time={getDataPerModules(["inicio"], 10).timePromedio}
                                repetitions={getDataPerModules(["inicio"], 10).errorsPromedio}>
                            </CardProgress>
                            <CardProgress module={"Final"} newUsers={100} title={"Aciertos promedio"}
                                value={getDataPerModules(["final"], 10).promedio}
                                maxValue={10} color="text-[#282828]"
                                time={getDataPerModules(["final"], 10).timePromedio}
                                repetitions={getDataPerModules(["final"], 10).errorsPromedio}>
                            </CardProgress>
                        </div>
                        <div className="flex py-3 gap-x-4 items-center">
                            <p className="text-[#686868] text-sm font-semibold">Datos analíticos</p>
                        </div>
                        <div className="flex gap-x-4 overflow-x-auto overflow-y-hidden">
                            <Meanings
                                meanings={[
                                    ['T1L1 : ', 'Venta ética: curar, no sólo vender'],
                                    ['T1L2 : ', '¡Nos gustan las cosas simples que funcionan!'],
                                    ['T1L3 : ', 'Nuestras familias comerciales'],
                                    ['T2L1 : ', 'Distribución de los espacios en farmacia'],
                                    ['T2L2 : ', 'Punto caliente'],
                                    ['T2L3 : ', 'Espacios de exhibiciones'],
                                    ['T3L1 : ', 'campañas y promociones'],
                                    ['T3L2 : ', 'Acomodo de anaqueles'],
                                    ['T3L3 : ', 'Exhibiciones'],
                                    ['T4L1 : ', 'Componente de anaqueles y exhibidores'],
                                    ['T4L2 : ', 'Materiales identificativos'],
                                    ['T4L3 : ', 'Boletín mensual']
                                ]}
                            />
                            <CardBarCharSimiVR
                                usersEnd={infoModules}
                                title={"Tiempo promedio por tarea"}
                                info={infoModules} ></CardBarCharSimiVR>
                            <CardBarCharSimiVR
                                usersEnd={infoModules}
                                type={"unique"}
                                title={"Número promedio de errores por tarea"}
                                info={infoModules} ></CardBarCharSimiVR>

                        </div>
                        <div className="py-6 flex gap-x-4">
                            <RankingSimiAR users={responseRanking} nameGrupo='Grupo' />
                            {/* <CardBarRadarSimiAR info={grupsInfo}></CardBarRadarSimiAR> */}

                        </div>
                    </div>
                </div>
            </CustomMainContent>
        </div>
    )
}
